module.exports = __webpack_public_path__ + "static/acon.e05200e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/references/acon.jpg
// module id = 203
// module chunks = 35783957827783 267625579013595